import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import axios from "@/axios";
import { i18n } from "@/i18n";
import Notification from "vue-notification";
import { sync } from "vuex-router-sync";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import VueGtag from "vue-gtag";
import dotenv from "dotenv";
import "@/validator";
import "@mdi/font/css/materialdesignicons.min.css";

Vue.config.productionTip = false;
dotenv.config();

Vue.use(Notification);
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_TAG_ID },
    disableScriptLoad: process.env.VUE_APP_DISABLE_GOOGLE_ANALYTICS_TAG === "true",
    appName: "AutoStream",
    pageTrackerScreenviewEnabled: true,
  },
  router
);

sync(store, router);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount("#app");
